import {Tooltip, OverlayTrigger, InputGroup, Button} from 'react-bootstrap'
import styles from './SettingInteger.css'

class SettingInteger extends React.Component {
  render () {
    let {input, meta, placeholder, readOnly, maxLength, dis = false, inputClassName, feedbackClassName, prefixText, prefixTextClassName, prefixTextClassNameError} = this.props
    let {touched, error} = meta
    return (
      <div className={
        touched
        ? (error ? 'has-feedback has-error' : 'has-feedback has-success')
        : ''}>
        {prefixText && <div className={touched ? error ? prefixTextClassNameError : prefixTextClassName : prefixTextClassName}>{prefixText}</div>}
        <InputGroup>
          <InputGroup.Button>
            <Button onClick={this._decrementInteger}>-</Button>
          </InputGroup.Button>
          <input {...input}
            type='text'
            readOnly={readOnly}
            maxLength={maxLength}
            className={`form-control ${inputClassName}`}
            placeholder={placeholder}
            onChange={this._onChange}
            onKeyPress={this._onKeyPress}
            disabled={dis}
          />
          <InputGroup.Button>
            <Button onClick={this._incrementInteger}>+</Button>
          </InputGroup.Button>
          {
            touched
            ? error
              ? <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>{error}</Tooltip>}>
                <span
                  className={`form-control-feedback glyphicon glyphicon-remove ${feedbackClassName} ${styles['icon-pos']}`}
                  style={{'pointer-events': 'auto', 'cursor': 'pointer'}}
                  />
              </OverlayTrigger>
              : <span className={`form-control-feedback glyphicon glyphicon-ok ${feedbackClassName} ${styles['icon-pos']}`} />
            : ''
          }
        </InputGroup>
      </div>
    )
  }

  _onKeyPress = (e) => {
    const numberRegex = /[0-9]/
    if (!numberRegex.test(e.key)) {
      e.preventDefault()
    }
  }

  _onChange = (e) => {
    const nextVal = e.target.value
    const {input: {onChange, value}, maxVal, minVal} = this.props
    let val
    if (isNaN(nextVal)) {
      val = value
    } else {
      val = parseInt(nextVal)
      if (val === 0) {
        val = value
      } else if (val > maxVal) {
        val = maxVal
      } else if (val < minVal) {
        val = minVal
      } else {
        val = nextVal
      }
    }
    onChange(val)
  }

  _incrementInteger = (e) => {
    const {input: {value, onChange}, maxVal, minVal} = this.props
    let nextVal = parseInt(value) + 1
    if (isNaN(value) || !value) {
      onChange(minVal)
    } else if (nextVal > maxVal) {
      onChange(maxVal)
    } else {
      onChange(nextVal)
    }
  }

  _decrementInteger = (e) => {
    const {input: {value, onChange}, minVal} = this.props
    let nextVal = parseInt(value) - 1
    if (isNaN(value) || !value) {
      onChange(minVal)
    } else if (nextVal < minVal) {
      onChange(minVal)
    } else {
      onChange(nextVal)
    }
  }
}

SettingInteger.propTypes = {
  positiveNumberOnly: React.PropTypes.bool
}

export default SettingInteger



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/SettingInteger/SettingInteger.js